import { PropsWithChildren, ReactElement } from 'react';
import { MdOutlineDoneAll } from 'react-icons/md';

type ConfirmationSectionProps = {
  title: string;
  checked?: boolean;
  rightElement?: ReactElement;
} & PropsWithChildren;

export const ConfirmationSection = ({ title, checked, rightElement, children }: ConfirmationSectionProps) => {
  return (
    <div className="flex flex-col gap-5">
      <div className="flex items-center justify-between">
        <div className="flex items-center text-l-sb gap-1">
          <div>{title}</div>
          {checked && <MdOutlineDoneAll className="text-success-30" />}
        </div>
        <div>{rightElement}</div>
      </div>
      {children}
    </div>
  );
};
